export class GlobalSetting {
    public id: number ;
    public idPpaVersion: number;
    
}

    

